import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { LanguageProvider } from "./context/LanguageContext";
import { Layout } from "./components/Layout";
import ScrollToTop from "./components/ScrollToTop";
import CookieConsent from "./components/CookieConsent";
import WhatsAppButton from "./components/WhatsAppButton";
import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import AboutPage from "./pages/AboutPage";
import ApproachPage from "./pages/ApproachPage";
import ContactPage from "./pages/ContactPage";
import PropertyManagementMallorcaPage from "./pages/PropertyManagementMallorcaPage";
import BendinatPage from "./pages/BendinatPage";
import SolDeMallorcaPage from "./pages/SolDeMallorcaPage";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <LanguageProvider>
          <BrowserRouter>
          <ScrollToTop />
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/approach" element={<ApproachPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/property-management-mallorca" element={<PropertyManagementMallorcaPage />} />
              <Route path="/bendinat" element={<BendinatPage />} />
              <Route path="/sol-de-mallorca" element={<SolDeMallorcaPage />} />
            </Routes>
          </Layout>
          <CookieConsent />
          <WhatsAppButton />
          </BrowserRouter>
        </LanguageProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
